import {
  IconApi,
  IconArchive,
  IconBell,
  IconBox,
  IconBrowser,
  IconBuildingFactory2,
  IconBuildingWarehouse,
  IconCalendarEvent,
  IconCar,
  IconCash,
  IconChartDonut2,
  IconChartDots,
  IconClipboardCheck,
  IconCloudComputing,
  IconCloudDownload,
  IconCpu,
  IconCreditCard,
  IconCubeSpark,
  IconEdit,
  IconFileAnalytics,
  IconFileCertificate,
  IconFileDollar,
  IconFileInvoice,
  IconFiles,
  IconFileSettings,
  IconFileSpreadsheet,
  IconFileTextSpark,
  IconFileUpload,
  IconForms,
  IconHomePlus,
  IconInbox,
  IconInfoCircle,
  IconList,
  IconListCheck,
  IconListDetails,
  IconListSearch,
  IconLockAccess,
  IconMailQuestion,
  IconMap2,
  IconMessageChatbot,
  IconPackage,
  IconParachute,
  IconPlaneDeparture,
  IconPlug,
  IconReceipt2,
  IconReplace,
  IconReportAnalytics,
  IconReportMoney,
  IconSearch,
  IconSend,
  IconSettings,
  IconShoppingCart,
  IconShoppingCartQuestion,
  IconSquareRoundedPlus,
  IconTable,
  IconTag,
  IconTerminal2,
  IconThumbUp,
  IconTimelineEvent,
  IconTruckDelivery,
  IconUser,
  IconUserPlus,
  IconUsers,
  IconUsersGroup,
  IconWorldSearch,
  IconZoomMoney,
} from '@tabler/icons-react';
import { MANAGED_INVENTORY_ROUTES } from 'routes/constants';
import { COLOR_OPTIONS } from 'types';
import {
  App,
  AppFeature,
  AppGroup,
  appPermissionAccessLevels,
  AppView,
} from 'types/apps';

export enum ALL_APP_IDS {
  ALTS = 'ALTS',
  BILLING = 'BILLING',
  BOMS = 'BOMS',
  COMPLIANCE = 'COMPLIANCE',
  DOCAI = 'DOCAI',
  INTEGRATIONS = 'INTEGRATIONS',
  KITTING = 'KITTING',
  MANAGED_INVENTORY = 'MANAGED_INVENTORY',
  ORDERS = 'ORDERS',
  ORG_SETTINGS = 'ORG_SETTINGS',
  PART_LIBRARY = 'PART_LIBRARY',
  PART_SEARCH = 'PART_SEARCH',
  PARTS = 'PARTS',
  PROCUREMENT = 'PROCUREMENT',
  PRODUCTION = 'PRODUCTION',
  PROPERTIES = 'PROPERTIES',
  REPORTING = 'REPORTING',
  REQUISITIONS = 'REQUISITIONS',
  SIMPLIFIED_BUYING_ORDERS = 'SIMPLIFIED_BUYING_ORDERS',
  SOURCING = 'SOURCING',
  STOCK = 'STOCK',
  SUPPLIERS = 'SUPPLIERS',
  USER_SETTINGS = 'USER_SETTINGS',
  USERS = 'USERS',
  WAREHOUSE = 'WAREHOUSE',
}

export enum ALL_VIEW_IDS {
  ADDRESSES = 'ADDRESSES',
  ALL_REQUISITIONS = 'ALL_REQUISITIONS',
  ALLOCATIONS = 'ALLOCATIONS',
  BILLING_INVOICES = 'BILLING_INVOICES',
  BILLING_PAYMENTS = 'BILLING_PAYMENTS',
  BILLING_USAGE = 'BILLING_USAGE',
  CARTS = 'CARTS',
  CUSTOM_PROPERTIES = 'CUSTOM_PROPERTIES',
  DOC_AI_EXTRACTORS = 'DOC_AI_EXTRACTORS',
  DOC_AI_INBOX = 'DOC_AI_INBOX',
  DOC_AI_PREFERENCES = 'DOC_AI_PREFERENCES',
  HANDLING_TASKS = 'HANDLING_TASKS',
  INTEGRATIONS_DESIGNER = 'INTEGRATIONS_DESIGNER',
  INTEGRATIONS_LEGACY = 'INTEGRATIONS_LEGACY',
  INTEGRATIONS_MARKETPLACE = 'INTEGRATIONS_MARKETPLACE',
  INVENTORY_PREFERENCES = 'INVENTORY_PREFERENCES',
  KITS = 'KITS',
  KITTING_PREFERENCES = 'KITTING_PREFERENCES',
  NOTIFICATIONS = 'NOTIFICATIONS',
  ORDER_PREFERENCES = 'ORDER_PREFERENCES',
  ORDERS_STATUS = 'ORDERS_STATUS',
  ORDERS_TABLE = 'ORDERS_TABLE',
  ORG_INFO = 'ORG_INFO',
  ORG_PREFERENCES = 'ORG_PREFERENCES',
  ORG_SUBORGS = 'ORG_SUBORGS',
  PART_ALL = 'PART_ALL',
  PART_STOCK = 'PART_STOCK',
  PARTS = 'PARTS',
  PARTS_DETAIL = 'PARTS_DETAIL',
  PROCUREMENT_APP_PACKING_SLIPS = 'PROCUREMENT_APP_PACKING_SLIPS',
  PROCUREMENT_DASHBOARD = 'PROCUREMENT_DASHBOARD',
  PROCUREMENT_PREFERENCES = 'PROCUREMENT_PREFERENCES',
  PROFILE = 'PROFILE',
  PURCHASE_RULES = 'PURCHASE_RULES',
  RECEIVE_AI_INBOX = 'RECEIVE_AI_INBOX',
  REPORTING_APP_BULK_IMPORT_EXPORT = 'REPORTING_APP_BULK_IMPORT_EXPORT',
  REPORTING_APP_SQL_QUERIES = 'REPORTING_APP_SQL_QUERIES',
  REPORTING_APP_TEMPLATES = 'REPORTING_APP_TEMPLATES',
  REQUISITIONS_TABLE = 'REQUISITIONS_TABLE',
  RFQ = 'RFQ',
  SECURITY = 'SECURITY',
  SHIPMENTS = 'SHIPMENTS',
  STOCK_LOCATIONS = 'STOCK_LOCATIONS',
  STOCK_LOTS = 'STOCK_LOTS',
  SUPPLIER_BILLS = 'SUPPLIER_BILLS',
  SUPPLIER_SEARCH = 'SUPPLIER_SEARCH',
  SUPPLIERS = 'SUPPLIERS',
  TAGS = 'TAGS',
  TEAMS_PREFERENCES = 'TEAMS_PREFERENCES',
  TEAMS_TABLE = 'TEAMS_TABLE',
  WAREHOUSE_SHIPMENTS = 'WAREHOUSE_SHIPMENTS',
  YOUR_ORDERS = 'YOUR_ORDERS',
  PURCHASE_ORDERS = 'PURCHASE_ORDERS',
  PROCUREMENT_BROWSER = 'PROCUREMENT_BROWSER',
  // SIMPLIFIED BUYING
  ORDERS_DASHBOARD = 'ORDERS_DASHBOARD',
  ALL_ORDERS = 'ALL_ORDERS',
  OPEN_CART = 'OPEN_CART',
  SUPPLIER_ORDERS = 'SUPPLIER_ORDERS',
  // SIMPLIFIED SOURCING
  SOURCING_DASHBOARD = 'SOURCING_DASHBOARD',
  SOURCING_RFQS = 'SOURCING_RFQS',
  OPEN_RFQ = 'OPEN_RFQ',
  QUOTE = 'QUOTE',
}

export enum INTEGRATION_ENTITY_IDS {
  ALTIUM_365 = 'ALTIUM_365',
  FILE = 'FILE',
  GOOGLE_SHEETS = 'GOOGLE_SHEETS',
}

export enum INTEGRATION_FLOW_IDS {
  BOMS = 'BOMS',
  CUSTOM_PARTS = 'CUSTOM_PARTS',
  ORDERS = 'ORDERS',
  PART_STOCK = 'PART_STOCK',
  STOCK_LOTS = 'STOCK_LOTS',
}

export enum ALL_FEATURE_IDS {
  AECQ = 'AECQ',
  APP_LEVEL_PERMISSIONS = 'APP_LEVEL_PERMISSIONS',
  BOMS_ALTIUM_365 = 'BOMS_ALTIUM_365',
  BOMS_GOOGLE_SHEETS = 'BOMS_GOOGLE_SHEETS',
  BULK_CREATE_EXPECTED = 'BULK_CREATE_EXPECTED',
  BULK_IMPORT_EXPORT = 'BULK_IMPORT_EXPORT',
  COFACTR_PAY = 'COFACTR_PAY',
  CREATE_EDIT_USER = 'CREATE_EDIT_USER',
  CREATE_READ_USER = 'CREATE_READ_USER',
  CUSTOM_PARTS = 'CUSTOM_PARTS',
  CUSTOM_PARTS_FILE = 'CUSTOM_PARTS_FILE',
  CUSTOM_PNS = 'CUSTOM_PNS',
  CUSTOM_SHIPPING_ACCOUNTS = 'CUSTOM_SHIPPING_ACCOUNTS',
  CUSTOMER_ORDER_API = 'CUSTOMER_ORDER_API',
  DROP_SHIPPING = 'DROP_SHIPPING',
  FILE_ATTACHMENTS = 'FILE_ATTACHMENTS',
  GENERATE_PO = 'GENERATE_PO',
  INTEGRATIONS_DESIGNER = 'INTEGRATIONS_DESIGNER',
  INTEGRATIONS_LEGACY = 'INTEGRATIONS_LEGACY',
  INTEGRATIONS_MARKETPLACE = 'INTEGRATIONS_MARKETPLACE',
  KITS_TEMP = 'KITS_TEMP',
  LEGACY_SHIPMENTS = 'LEGACY_SHIPMENTS',
  MANAGED_ORDERS = 'MANAGED_ORDERS',
  NON_PART_PURCHASE_LINES = 'NON_PART_PURCHASE_LINES',
  ORDER_APPROVALS = 'ORDER_APPROVALS',
  ORDERS_GOOGLE_SHEETS = 'ORDERS_GOOGLE_SHEETS',
  PART_STOCK_GOOGLE_SHEETS = 'PART_STOCK_GOOGLE_SHEETS',
  PROCESSING_ORG = 'PROCESSING_ORG',
  PROCESSING_ORG_EMAIL = 'PROCESSING_ORG_EMAIL',
  PROCESSING_ORG_SCAN = 'PROCESSING_ORG_SCAN',
  PROCUREMENT_PACKING_SLIPS = 'PROCUREMENT_PACKING_SLIPS',
  PURCHASING_RELEASE_DATES = 'PURCHASING_RELEASE_DATES',
  RECEIVE_AI_INBOX = 'RECEIVE_AI_INBOX',
  RFQS = 'RFQS',
  SHIP_TO_WAREHOUSE = 'SHIP_TO_WAREHOUSE',
  SIMPLIFIED_BUYING = 'SIMPLIFIED_BUYING',
  SIMPLE_PART_CREATION = 'SIMPLE_PART_CREATION',
  SQL_QUERIES = 'SQL_QUERIES',
  STOCK_LOTS_FILE = 'STOCK_LOTS_FILE',
  STOCK_LOTS_GOOGLE_SHEETS = 'STOCK_LOTS_GOOGLE_SHEETS',
  SUB_ORGS = 'SUB_ORGS',
  SUPPLIER_BILLS = 'SUPPLIER_BILLS',
  SUPPLIER_ONLINE_CHECKOUT = 'SUPPLIER_ONLINE_CHECKOUT',
  SUPPLIER_ORDER_API = 'SUPPLIER_ORDER_API',
  SUPPLIER_PRICING_API = 'SUPPLIER_PRICING_API',
  SUPPLIER_SEARCH = 'SUPPLIER_SEARCH',
  PROCUREMENT_BROWSER = 'PROCUREMENT_BROWSER',
}

export enum ALL_APP_GROUP_IDS {
  INVENTORY = 'INVENTORY',
  PARTS = 'PARTS',
  PROCUREMENT = 'PROCUREMENT',
}

export const ALL_APP_GROUPS: { [key in ALL_APP_GROUP_IDS]: AppGroup } = {
  [ALL_APP_GROUP_IDS.PARTS]: {
    id: ALL_APP_GROUP_IDS.PARTS,
    name: 'Parts',
    icon: IconCpu,
  },
  [ALL_APP_GROUP_IDS.PROCUREMENT]: {
    id: ALL_APP_GROUP_IDS.PROCUREMENT,
    name: 'Procurement',
    icon: IconReportMoney,
  },
  [ALL_APP_GROUP_IDS.INVENTORY]: {
    id: ALL_APP_GROUP_IDS.INVENTORY,
    name: 'Inventory',
    icon: IconPackage,
  },
};

export const ALL_FEATURES: { [key in ALL_FEATURE_IDS]: AppFeature } = {
  [ALL_FEATURE_IDS.CUSTOM_PARTS]: {
    id: ALL_FEATURE_IDS.CUSTOM_PARTS,
    name: 'Custom Parts',
    icon: IconSquareRoundedPlus,
    globalComingSoon: false,
    globalBeta: false,
  },
  [ALL_FEATURE_IDS.CUSTOM_PNS]: {
    id: ALL_FEATURE_IDS.CUSTOM_PNS,
    name: 'Custom Part Number',
    icon: IconEdit,
    globalComingSoon: false,
    globalBeta: false,
  },
  [ALL_FEATURE_IDS.AECQ]: {
    id: ALL_FEATURE_IDS.AECQ,
    name: 'AEC-Q Compliance',
    icon: IconCar,
    globalComingSoon: false,
    globalBeta: false,
  },
  [ALL_FEATURE_IDS.DROP_SHIPPING]: {
    id: ALL_FEATURE_IDS.DROP_SHIPPING,
    name: 'Drop Shipping',
    icon: IconParachute,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.BULK_CREATE_EXPECTED]: {
    id: ALL_FEATURE_IDS.BULK_CREATE_EXPECTED,
    name: 'Bulk Create Expected',
    icon: IconListCheck,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: true,
  },
  [ALL_FEATURE_IDS.APP_LEVEL_PERMISSIONS]: {
    id: ALL_FEATURE_IDS.APP_LEVEL_PERMISSIONS,
    name: 'App Level Permissions',
    icon: IconLockAccess,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.CREATE_EDIT_USER]: {
    id: ALL_FEATURE_IDS.CREATE_EDIT_USER,
    name: 'Create Edit User',
    icon: IconUserPlus,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.CREATE_READ_USER]: {
    id: ALL_FEATURE_IDS.CREATE_READ_USER,
    name: 'App Level Permissions',
    icon: IconUserPlus,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.BOMS_GOOGLE_SHEETS]: {
    id: ALL_FEATURE_IDS.BOMS_GOOGLE_SHEETS,
    name: 'BOM Google Sheets',
    icon: IconPlug,
    globalComingSoon: false,
    globalBeta: false,
  },
  [ALL_FEATURE_IDS.BOMS_ALTIUM_365]: {
    id: ALL_FEATURE_IDS.BOMS_ALTIUM_365,
    name: 'BOM Altium 365',
    icon: IconPlug,
    globalComingSoon: false,
    globalBeta: false,
  },
  [ALL_FEATURE_IDS.ORDERS_GOOGLE_SHEETS]: {
    id: ALL_FEATURE_IDS.ORDERS_GOOGLE_SHEETS,
    name: 'Orders Google Sheets',
    icon: IconPlug,
    globalComingSoon: false,
    globalBeta: false,
  },
  [ALL_FEATURE_IDS.PART_STOCK_GOOGLE_SHEETS]: {
    id: ALL_FEATURE_IDS.PART_STOCK_GOOGLE_SHEETS,
    name: 'Part Stock Google Sheets',
    icon: IconPlug,
    globalComingSoon: false,
    globalBeta: false,
  },
  [ALL_FEATURE_IDS.STOCK_LOTS_GOOGLE_SHEETS]: {
    id: ALL_FEATURE_IDS.STOCK_LOTS_GOOGLE_SHEETS,
    name: 'Stock Lots Google Sheets',
    icon: IconPlug,
    globalComingSoon: false,
    globalBeta: false,
  },
  [ALL_FEATURE_IDS.CUSTOM_PARTS_FILE]: {
    id: ALL_FEATURE_IDS.CUSTOM_PARTS_FILE,
    name: 'Custom Parts File',
    icon: IconPlug,
    globalComingSoon: false,
    globalBeta: false,
  },
  [ALL_FEATURE_IDS.STOCK_LOTS_FILE]: {
    id: ALL_FEATURE_IDS.STOCK_LOTS_FILE,
    name: 'Stock Lots File',
    icon: IconPlug,
    globalComingSoon: false,
    globalBeta: false,
  },
  [ALL_FEATURE_IDS.GENERATE_PO]: {
    id: ALL_FEATURE_IDS.GENERATE_PO,
    name: 'Order via PO',
    icon: IconFileInvoice,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.MANAGED_ORDERS]: {
    id: ALL_FEATURE_IDS.MANAGED_ORDERS,
    name: 'Order via Managed Orders',
    icon: IconMessageChatbot,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.CUSTOMER_ORDER_API]: {
    id: ALL_FEATURE_IDS.CUSTOMER_ORDER_API,
    name: 'Order via Customer API',
    icon: IconApi,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.PURCHASING_RELEASE_DATES]: {
    id: ALL_FEATURE_IDS.PURCHASING_RELEASE_DATES,
    name: 'Purchasing Release Dates',
    icon: IconCalendarEvent,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.SUB_ORGS]: {
    id: ALL_FEATURE_IDS.SUB_ORGS,
    name: 'Sub-Organizations',
    icon: IconHomePlus,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.PROCESSING_ORG]: {
    id: ALL_FEATURE_IDS.PROCESSING_ORG,
    name: 'Order Processing Org',
    icon: IconFileUpload,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.PROCESSING_ORG_EMAIL]: {
    id: ALL_FEATURE_IDS.PROCESSING_ORG_EMAIL,
    name: 'Processing Org - Email Inbox',
    icon: IconInbox,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.PROCESSING_ORG_SCAN]: {
    id: ALL_FEATURE_IDS.PROCESSING_ORG_SCAN,
    name: 'Processing Org - Scanning',
    icon: IconInbox,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.ORDER_APPROVALS]: {
    id: ALL_FEATURE_IDS.ORDER_APPROVALS,
    name: 'Order Approvals',
    icon: IconThumbUp,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.CUSTOM_SHIPPING_ACCOUNTS]: {
    id: ALL_FEATURE_IDS.CUSTOM_SHIPPING_ACCOUNTS,
    name: 'Custom Shipping Accounts',
    icon: IconPlaneDeparture,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.SUPPLIER_BILLS]: {
    id: ALL_FEATURE_IDS.SUPPLIER_BILLS,
    name: 'Supplier Bills',
    icon: IconReceipt2,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.SUPPLIER_SEARCH]: {
    id: ALL_FEATURE_IDS.SUPPLIER_SEARCH,
    name: 'Supplier Search',
    icon: IconWorldSearch,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.PROCUREMENT_PACKING_SLIPS]: {
    id: ALL_FEATURE_IDS.PROCUREMENT_PACKING_SLIPS,
    name: 'Procurement App Packing Slips',
    icon: IconClipboardCheck,
    globalComingSoon: true,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.NON_PART_PURCHASE_LINES]: {
    id: ALL_FEATURE_IDS.NON_PART_PURCHASE_LINES,
    name: 'Non-Part Purchase Order Lines',
    icon: IconList,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.COFACTR_PAY]: {
    id: ALL_FEATURE_IDS.COFACTR_PAY,
    name: 'Cofactr Pay',
    icon: IconReceipt2,
    globalComingSoon: true,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.SUPPLIER_PRICING_API]: {
    id: ALL_FEATURE_IDS.SUPPLIER_PRICING_API,
    name: 'Supplier Pricing API',
    icon: IconApi,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.SUPPLIER_ORDER_API]: {
    id: ALL_FEATURE_IDS.SUPPLIER_ORDER_API,
    name: 'Supplier Order API',
    icon: IconApi,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.SUPPLIER_ONLINE_CHECKOUT]: {
    id: ALL_FEATURE_IDS.SUPPLIER_ONLINE_CHECKOUT,
    name: 'Supplier Online Checkout',
    icon: IconBrowser,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.SQL_QUERIES]: {
    id: ALL_FEATURE_IDS.SQL_QUERIES,
    name: 'SQL Explorer',
    icon: IconTerminal2,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.INTEGRATIONS_MARKETPLACE]: {
    id: ALL_FEATURE_IDS.INTEGRATIONS_MARKETPLACE,
    name: 'Available Integrations',
    icon: IconPlug,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.INTEGRATIONS_DESIGNER]: {
    id: ALL_FEATURE_IDS.INTEGRATIONS_DESIGNER,
    name: 'Workflow Studio',
    icon: IconCloudComputing,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.INTEGRATIONS_LEGACY]: {
    id: ALL_FEATURE_IDS.INTEGRATIONS_LEGACY,
    name: 'Legacy Integrations',
    icon: IconArchive,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.FILE_ATTACHMENTS]: {
    id: ALL_FEATURE_IDS.FILE_ATTACHMENTS,
    name: 'File Attachments',
    icon: IconFiles,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.RECEIVE_AI_INBOX]: {
    id: ALL_FEATURE_IDS.RECEIVE_AI_INBOX,
    name: 'Receive AI Inbox',
    icon: IconInbox,
    globalComingSoon: false,
    globalBeta: false,
  },
  [ALL_FEATURE_IDS.SHIP_TO_WAREHOUSE]: {
    id: ALL_FEATURE_IDS.SHIP_TO_WAREHOUSE,
    name: 'Ship To Warehouse',
    icon: IconPlaneDeparture,
    globalComingSoon: false,
    globalBeta: false,
  },
  // TODO: Remove this feature once KITS view is fully launched to customers
  [ALL_FEATURE_IDS.KITS_TEMP]: {
    id: ALL_FEATURE_IDS.KITS_TEMP,
    name: 'Kits',
    icon: IconBox,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.BULK_IMPORT_EXPORT]: {
    id: ALL_FEATURE_IDS.BULK_IMPORT_EXPORT,
    name: 'Bulk Import/Export',
    icon: IconCloudDownload,
    globalComingSoon: false,
    globalBeta: true,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.LEGACY_SHIPMENTS]: {
    id: ALL_FEATURE_IDS.LEGACY_SHIPMENTS,
    name: 'Shipments',
    icon: IconPlaneDeparture,
    globalComingSoon: false,
    globalBeta: false,
  },
  [ALL_FEATURE_IDS.SIMPLE_PART_CREATION]: {
    id: ALL_FEATURE_IDS.SIMPLE_PART_CREATION,
    name: 'Simplified Part Creation',
    icon: IconCpu,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.RFQS]: {
    id: ALL_FEATURE_IDS.RFQS,
    name: 'RFQs',
    icon: IconMailQuestion,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.SIMPLIFIED_BUYING]: {
    id: ALL_FEATURE_IDS.SIMPLIFIED_BUYING,
    name: 'Simplified Buying',
    icon: IconShoppingCart,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
  [ALL_FEATURE_IDS.PROCUREMENT_BROWSER]: {
    id: ALL_FEATURE_IDS.PROCUREMENT_BROWSER,
    name: 'Procurement Browser',
    icon: IconBrowser,
    globalComingSoon: false,
    globalBeta: false,
    inheritParentPermissions: false,
  },
};

export const ALL_VIEWS: { [key in ALL_VIEW_IDS]: AppView } = {
  [ALL_VIEW_IDS.PART_ALL]: {
    id: ALL_VIEW_IDS.PART_ALL,
    name: 'All Parts',
    icon: IconListSearch,
    path: '/part-library/all-parts',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.YOUR_ORDERS]: {
    id: ALL_VIEW_IDS.YOUR_ORDERS,
    name: 'Carts',
    icon: IconShoppingCart,
    path: '/orders/snapshots',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.CARTS]: {
    id: ALL_VIEW_IDS.CARTS,
    name: 'Carts',
    icon: IconShoppingCart,
    path: '/orders/carts',
    includeInSidebar: false,
  },
  [ALL_VIEW_IDS.ORDERS_STATUS]: {
    id: ALL_VIEW_IDS.ORDERS_STATUS,
    name: 'Supplier Order Status',
    icon: IconTimelineEvent,
    path: '/orders/status',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.ORDERS_TABLE]: {
    id: ALL_VIEW_IDS.ORDERS_TABLE,
    name: 'All Supplier Orders',
    icon: IconTruckDelivery,
    path: '/orders/table',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.ORDER_PREFERENCES]: {
    id: ALL_VIEW_IDS.ORDER_PREFERENCES,
    name: 'Order Preferences',
    icon: IconSettings,
    path: '/orders/preferences',
    includeInSidebar: false,
    inheritParentPermissions: false,
    inheritedFeatureEntitlement: ALL_FEATURE_IDS.ORDER_APPROVALS,
  },
  [ALL_VIEW_IDS.SHIPMENTS]: {
    id: ALL_VIEW_IDS.SHIPMENTS,
    name: 'Shipments',
    icon: IconPlaneDeparture,
    path: '/kitting/shipping',
    deprecatedPath: '/inventory/shipping',
    includeInSidebar: true,
    inheritParentPermissions: false,
    inheritedFeatureEntitlement: ALL_FEATURE_IDS.LEGACY_SHIPMENTS,
  },
  [ALL_VIEW_IDS.WAREHOUSE_SHIPMENTS]: {
    id: ALL_VIEW_IDS.WAREHOUSE_SHIPMENTS,
    name: 'Ship to Warehouse',
    icon: IconPlaneDeparture,
    path: '/kitting/ship-to-warehouse',
    includeInSidebar: true,
    inheritParentPermissions: false,
    inheritedFeatureEntitlement: ALL_FEATURE_IDS.SHIP_TO_WAREHOUSE,
  },
  [ALL_VIEW_IDS.ADDRESSES]: {
    id: ALL_VIEW_IDS.ADDRESSES,
    name: 'Addresses',
    icon: IconMap2,
    path: '/kitting/addresses',
    includeInSidebar: true,
    inheritParentPermissions: true,
    deprecatedPath: '/kitting/stock-locations',
  },
  [ALL_VIEW_IDS.KITTING_PREFERENCES]: {
    id: ALL_VIEW_IDS.KITTING_PREFERENCES,
    name: 'Shipping Preferences',
    icon: IconSettings,
    path: '/kitting/preferences',
    includeInSidebar: false,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.PART_STOCK]: {
    id: ALL_VIEW_IDS.PART_STOCK,
    name: 'Part Stock',
    icon: IconCpu,
    path: '/stock/part-stock',
    deprecatedPath: '/inventory/parts',
    includeInSidebar: true,
    excludeInBlended: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.STOCK_LOTS]: {
    id: ALL_VIEW_IDS.STOCK_LOTS,
    name: 'Stock Lots',
    icon: IconPackage,
    path: '/stock/stock-lots',
    deprecatedPath: '/inventory/stock-lots',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.ALLOCATIONS]: {
    id: ALL_VIEW_IDS.ALLOCATIONS,
    name: 'Allocations',
    icon: IconChartDonut2,
    path: '/stock/allocations',
    deprecatedPath: '/inventory/allocations',
    includeInSidebar: true,
    excludeInBlended: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.HANDLING_TASKS]: {
    id: ALL_VIEW_IDS.HANDLING_TASKS,
    name: 'Handling Tasks',
    icon: IconListCheck,
    path: '/managed-inventory/handling-tasks',
    deprecatedPath: '/inventory/handling-requests',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.STOCK_LOCATIONS]: {
    id: ALL_VIEW_IDS.STOCK_LOCATIONS,
    name: 'Stock Locations',
    icon: IconBuildingWarehouse,
    path: '/managed-inventory/stock-locations',
    deprecatedPath: '/inventory/locations',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.INVENTORY_PREFERENCES]: {
    id: ALL_VIEW_IDS.INVENTORY_PREFERENCES,
    name: 'Inventory Preferences',
    icon: IconSettings,
    path: '/managed-inventory/preferences',
    includeInSidebar: false,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.SUPPLIERS]: {
    id: ALL_VIEW_IDS.SUPPLIERS,
    name: 'Suppliers',
    icon: IconBuildingFactory2,
    path: '/suppliers/suppliers',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.PURCHASE_RULES]: {
    id: ALL_VIEW_IDS.PURCHASE_RULES,
    name: 'Purchase Rules',
    icon: IconZoomMoney,
    path: '/suppliers/purchase-rules',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.BILLING_USAGE]: {
    id: ALL_VIEW_IDS.BILLING_USAGE,
    name: 'Usage',
    icon: IconChartDots,
    path: '/billing/usage',
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.BILLING_INVOICES]: {
    id: ALL_VIEW_IDS.BILLING_INVOICES,
    name: 'Invoices',
    icon: IconFileInvoice,
    path: '/billing/invoices',
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.BILLING_PAYMENTS]: {
    id: ALL_VIEW_IDS.BILLING_PAYMENTS,
    name: 'Payments',
    icon: IconCreditCard,
    path: '/billing/payments',
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.ORG_INFO]: {
    id: ALL_VIEW_IDS.ORG_INFO,
    name: 'Info',
    icon: IconInfoCircle,
    path: '/org/info',
    includeInSidebar: false,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.ORG_PREFERENCES]: {
    id: ALL_VIEW_IDS.ORG_PREFERENCES,
    name: 'Preferences',
    icon: IconSettings,
    path: '/org/preferences',
    includeInSidebar: false,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.ORG_SUBORGS]: {
    id: ALL_VIEW_IDS.ORG_SUBORGS,
    name: 'Sub-Organizations',
    icon: IconHomePlus,
    path: '/org/sub-orgs',
    includeInSidebar: false,
    inheritedFeatureEntitlement: ALL_FEATURE_IDS.SUB_ORGS,
  },
  [ALL_VIEW_IDS.PROFILE]: {
    id: ALL_VIEW_IDS.PROFILE,
    name: 'Profile',
    icon: IconUser,
    path: '/user-settings/profile',
    deprecatedPath: '/account/profile',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.SECURITY]: {
    id: ALL_VIEW_IDS.SECURITY,
    name: 'Security',
    icon: IconLockAccess,
    path: '/user-settings/security',
    deprecatedPath: '/account/security',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.NOTIFICATIONS]: {
    id: ALL_VIEW_IDS.NOTIFICATIONS,
    name: 'Notifications',
    icon: IconBell,
    path: '/user-settings/notifications',
    deprecatedPath: '/account/notifications',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.PROCUREMENT_DASHBOARD]: {
    id: ALL_VIEW_IDS.PROCUREMENT_DASHBOARD,
    name: 'Open POs',
    icon: IconTimelineEvent,
    path: '/procurement/open-orders',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.REQUISITIONS_TABLE]: {
    id: ALL_VIEW_IDS.REQUISITIONS_TABLE,
    name: 'Requisitions',
    icon: IconShoppingCartQuestion,
    path: '/requisitions/table',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.ALL_REQUISITIONS]: {
    id: ALL_VIEW_IDS.ALL_REQUISITIONS,
    name: 'All Requisitions',
    icon: IconTable,
    path: '/requisitions/all',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.PROCUREMENT_APP_PACKING_SLIPS]: {
    id: ALL_VIEW_IDS.PROCUREMENT_APP_PACKING_SLIPS,
    name: 'Packing Slips',
    icon: IconClipboardCheck,
    path: '/procurement/packing-slips',
    includeInSidebar: true,
    inheritParentPermissions: false,
    inheritedFeatureEntitlement: ALL_FEATURE_IDS.PROCUREMENT_PACKING_SLIPS,
  },
  [ALL_VIEW_IDS.SUPPLIER_BILLS]: {
    id: ALL_VIEW_IDS.SUPPLIER_BILLS,
    name: 'Supplier Bills',
    icon: IconReceipt2,
    path: '/procurement/supplier-bills',
    includeInSidebar: true,
    inheritParentPermissions: false,
    excludeInBlended: true,
    inheritedFeatureEntitlement: ALL_FEATURE_IDS.SUPPLIER_BILLS,
  },
  [ALL_VIEW_IDS.DOC_AI_INBOX]: {
    id: ALL_VIEW_IDS.DOC_AI_INBOX,
    name: 'Inbox',
    icon: IconInbox,
    path: '/docai/inbox',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.DOC_AI_EXTRACTORS]: {
    id: ALL_VIEW_IDS.DOC_AI_EXTRACTORS,
    name: 'Extractors',
    icon: IconFileSettings,
    path: '/docai/extractors',
    includeInSidebar: false,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.DOC_AI_PREFERENCES]: {
    id: ALL_VIEW_IDS.DOC_AI_PREFERENCES,
    name: 'DocAI Preferences',
    icon: IconSettings,
    path: '/docai/templates',
    includeInSidebar: false,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.PROCUREMENT_PREFERENCES]: {
    id: ALL_VIEW_IDS.PROCUREMENT_PREFERENCES,
    name: 'Procurement Preferences',
    icon: IconSettings,
    path: '/procurement/preferences',
    includeInSidebar: false,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.REPORTING_APP_SQL_QUERIES]: {
    id: ALL_VIEW_IDS.REPORTING_APP_SQL_QUERIES,
    name: 'SQL Explorer',
    icon: IconTerminal2,
    path: '/reporting/sql',
    includeInSidebar: true,
    inheritParentPermissions: false,
    inheritedFeatureEntitlement: ALL_FEATURE_IDS.SQL_QUERIES,
  },
  [ALL_VIEW_IDS.REPORTING_APP_TEMPLATES]: {
    id: ALL_VIEW_IDS.REPORTING_APP_TEMPLATES,
    name: 'Report Templates',
    icon: IconFileAnalytics,
    path: '/reporting/templates',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.REPORTING_APP_BULK_IMPORT_EXPORT]: {
    id: ALL_VIEW_IDS.REPORTING_APP_BULK_IMPORT_EXPORT,
    name: 'Bulk Import/Export',
    icon: IconCloudDownload,
    path: '/reporting/bulk-import-export',
    includeInSidebar: true,
    inheritParentPermissions: false,
    globalBeta: true,
    inheritedFeatureEntitlement: ALL_FEATURE_IDS.BULK_IMPORT_EXPORT,
  },
  [ALL_VIEW_IDS.INTEGRATIONS_LEGACY]: {
    id: ALL_VIEW_IDS.INTEGRATIONS_LEGACY,
    name: 'Legacy',
    icon: IconArchive,
    path: '/integrations/legacy',
    inheritParentPermissions: false,
    inheritedFeatureEntitlement: ALL_FEATURE_IDS.INTEGRATIONS_LEGACY,
  },
  [ALL_VIEW_IDS.INTEGRATIONS_MARKETPLACE]: {
    id: ALL_VIEW_IDS.INTEGRATIONS_MARKETPLACE,
    name: 'Available Integrations',
    icon: IconPlug,
    path: '/integrations/marketplace',
    inheritParentPermissions: false,
    inheritedFeatureEntitlement: ALL_FEATURE_IDS.INTEGRATIONS_MARKETPLACE,
  },
  [ALL_VIEW_IDS.INTEGRATIONS_DESIGNER]: {
    id: ALL_VIEW_IDS.INTEGRATIONS_DESIGNER,
    name: 'Workflow Studio',
    icon: IconCloudComputing,
    path: '/integrations/designer',
    inheritParentPermissions: false,
    inheritedFeatureEntitlement: ALL_FEATURE_IDS.INTEGRATIONS_DESIGNER,
  },
  [ALL_VIEW_IDS.TEAMS_TABLE]: {
    id: ALL_VIEW_IDS.TEAMS_TABLE,
    name: 'Teams',
    icon: IconUsersGroup,
    path: '/properties/teams',
    includeInSidebar: false,
    inheritParentPermissions: true,
    globalBeta: true,
  },
  [ALL_VIEW_IDS.TEAMS_PREFERENCES]: {
    id: ALL_VIEW_IDS.TEAMS_PREFERENCES,
    name: 'Team Preferences',
    icon: IconSettings,
    path: '/properties/team-preferences',
    includeInSidebar: false,
    inheritParentPermissions: true,
    globalBeta: true,
  },
  [ALL_VIEW_IDS.CUSTOM_PROPERTIES]: {
    id: ALL_VIEW_IDS.CUSTOM_PROPERTIES,
    name: 'Custom Properties',
    icon: IconForms,
    path: '/properties/custom-properties',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.TAGS]: {
    id: ALL_VIEW_IDS.TAGS,
    name: 'Tags',
    icon: IconTag,
    path: '/properties/tags',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.KITS]: {
    id: ALL_VIEW_IDS.KITS,
    name: 'Kits',
    icon: IconBox,
    path: '/kitting/kits',
    includeInSidebar: true,
    inheritParentPermissions: true,
    inheritedFeatureEntitlement: ALL_FEATURE_IDS.KITS_TEMP,
  },
  [ALL_VIEW_IDS.RFQ]: {
    id: ALL_VIEW_IDS.RFQ,
    name: 'RFQs',
    icon: IconMailQuestion,
    path: '/sourcing/rfq',
    includeInSidebar: true,
    inheritParentPermissions: false,
    inheritedFeatureEntitlement: ALL_FEATURE_IDS.RFQS,
  },
  [ALL_VIEW_IDS.SUPPLIER_SEARCH]: {
    id: ALL_VIEW_IDS.SUPPLIER_SEARCH,
    name: 'Supplier Search',
    icon: IconWorldSearch,
    path: '/sourcing/supplier-search',
    includeInSidebar: true,
    inheritParentPermissions: false,
    inheritedFeatureEntitlement: ALL_FEATURE_IDS.SUPPLIER_SEARCH,
  },
  [ALL_VIEW_IDS.PARTS]: {
    id: ALL_VIEW_IDS.PARTS,
    name: 'Parts',
    icon: IconCpu,
    path: '/parts',
    includeInSidebar: false,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.PARTS_DETAIL]: {
    id: ALL_VIEW_IDS.PARTS_DETAIL,
    name: 'Part',
    icon: IconCpu,
    path: '/parts',
    includeInSidebar: false,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.RECEIVE_AI_INBOX]: {
    id: ALL_VIEW_IDS.RECEIVE_AI_INBOX,
    name: 'Receive AI Inbox',
    icon: IconCubeSpark,
    path: '/receive-ai-inbox',
    inheritParentPermissions: true,
    includeInSidebar: true,
    inheritedFeatureEntitlement: ALL_FEATURE_IDS.RECEIVE_AI_INBOX,
  },
  [ALL_VIEW_IDS.PURCHASE_ORDERS]: {
    id: ALL_VIEW_IDS.PURCHASE_ORDERS,
    name: 'Purchase Orders',
    icon: IconFileSpreadsheet,
    path: '/procurement/purchase-orders',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  // SIMPLIFIED BUYING
  [ALL_VIEW_IDS.ORDERS_DASHBOARD]: {
    id: ALL_VIEW_IDS.ORDERS_DASHBOARD,
    name: 'Open Orders',
    icon: IconTimelineEvent,
    path: '/cart-orders/dashboard',
    includeInSidebar: true,
    inheritParentPermissions: true,
    globalComingSoon: true,
  },
  [ALL_VIEW_IDS.ALL_ORDERS]: {
    id: ALL_VIEW_IDS.ALL_ORDERS,
    name: 'Ordered Carts',
    icon: IconShoppingCart,
    path: '/cart-orders/orders',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.OPEN_CART]: {
    id: ALL_VIEW_IDS.OPEN_CART,
    name: 'Open Cart',
    icon: IconShoppingCart,
    path: '/cart-orders/carts',
    includeInSidebar: false,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.SUPPLIER_ORDERS]: {
    id: ALL_VIEW_IDS.SUPPLIER_ORDERS,
    name: 'Supplier Orders',
    icon: IconFileDollar,
    path: '/cart-orders/supplier-orders',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  // SIMPLIFIED SOURCING
  [ALL_VIEW_IDS.SOURCING_DASHBOARD]: {
    id: ALL_VIEW_IDS.SOURCING_DASHBOARD,
    name: 'Open RFQs',
    icon: IconTimelineEvent,
    path: '/sourcing/dashboard',
    includeInSidebar: true,
    inheritParentPermissions: false,
    inheritedFeatureEntitlement: ALL_FEATURE_IDS.SIMPLIFIED_BUYING,
    globalComingSoon: true,
  },
  [ALL_VIEW_IDS.SOURCING_RFQS]: {
    id: ALL_VIEW_IDS.SOURCING_RFQS,
    name: 'RFQs',
    icon: IconSend,
    path: '/sourcing/rfqs',
    includeInSidebar: true,
    inheritParentPermissions: false,
    inheritedFeatureEntitlement: ALL_FEATURE_IDS.SIMPLIFIED_BUYING,
  },
  [ALL_VIEW_IDS.OPEN_RFQ]: {
    id: ALL_VIEW_IDS.OPEN_RFQ,
    name: 'Open RFQ',
    icon: IconSend,
    path: '/sourcing/open-rfqs',
    includeInSidebar: false,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.QUOTE]: {
    id: ALL_VIEW_IDS.QUOTE,
    name: 'Supplier Quotes',
    icon: IconReportMoney,
    path: '/sourcing/quotes',
    includeInSidebar: true,
    inheritParentPermissions: true,
  },
  [ALL_VIEW_IDS.PROCUREMENT_BROWSER]: {
    id: ALL_VIEW_IDS.PROCUREMENT_BROWSER,
    name: 'Browser',
    icon: IconBrowser,
    path: '/procurement/browser',
    includeInSidebar: true,
    inheritParentPermissions: false,
    inheritedFeatureEntitlement: ALL_FEATURE_IDS.PROCUREMENT_BROWSER,
  },
};

export const ALL_APPS: { [key in ALL_APP_IDS]: App } = {
  [ALL_APP_IDS.PARTS]: {
    id: ALL_APP_IDS.PARTS,
    name: 'Parts',
    icon: IconCpu,
    path: '/parts',
    includeInSidebar: true,
    globalEnabled: false,
    requiredPermissionLevel: appPermissionAccessLevels.read,
    features: featureMap([ALL_FEATURE_IDS.SIMPLE_PART_CREATION]),
  },
  [ALL_APP_IDS.PART_SEARCH]: {
    id: ALL_APP_IDS.PART_SEARCH,
    name: 'Part Search',
    icon: IconSearch,
    path: '/parts-search',
    deprecatedPath: '/parts/search',
    appGroup: ALL_APP_GROUPS.PARTS,
    includeInSidebar: true,
    globalEnabled: false,
    requiredPermissionLevel: appPermissionAccessLevels.read,
  },
  [ALL_APP_IDS.PART_LIBRARY]: {
    id: ALL_APP_IDS.PART_LIBRARY,
    name: 'Part Library',
    icon: IconCpu,
    path: '/part-library',
    appGroup: ALL_APP_GROUPS.PARTS,
    includeInSidebar: true,
    globalEnabled: false,
    requiredPermissionLevel: appPermissionAccessLevels.read,
    views: viewMap([ALL_VIEW_IDS.PART_ALL]),
    features: featureMap([
      ALL_FEATURE_IDS.CUSTOM_PARTS,
      ALL_FEATURE_IDS.CUSTOM_PNS,
    ]),
  },
  [ALL_APP_IDS.ALTS]: {
    id: ALL_APP_IDS.ALTS,
    name: 'Alternates',
    icon: IconReplace,
    path: null,
    appGroup: ALL_APP_GROUPS.PARTS,
    includeInSidebar: false,
    globalEnabled: false,
    requiredPermissionLevel: appPermissionAccessLevels.read,
  },
  [ALL_APP_IDS.COMPLIANCE]: {
    id: ALL_APP_IDS.COMPLIANCE,
    name: 'Compliance & Risk',
    icon: IconFileCertificate,
    path: null,
    appGroup: ALL_APP_GROUPS.PARTS,
    includeInSidebar: false,
    globalEnabled: false,
    features: featureMap([ALL_FEATURE_IDS.AECQ]),
  },
  [ALL_APP_IDS.BOMS]: {
    id: ALL_APP_IDS.BOMS,
    name: 'BOMs',
    icon: IconListDetails,
    path: '/boms',
    appGroup: null,
    includeInSidebar: true,
    includeInBlended: true,
    globalEnabled: false,
    isRequiredFor: [ALL_APP_IDS.PRODUCTION],
  },
  [ALL_APP_IDS.REQUISITIONS]: {
    id: ALL_APP_IDS.REQUISITIONS,
    name: 'Requisitions',
    icon: IconShoppingCartQuestion,
    path: '/requisitions',
    appGroup: ALL_APP_GROUPS.PROCUREMENT,
    includeInSidebar: true,
    includeInBlended: true,
    globalEnabled: false,
    globalBeta: false,
    views: viewMap([
      ALL_VIEW_IDS.REQUISITIONS_TABLE,
      ALL_VIEW_IDS.ALL_REQUISITIONS,
    ]),
  },
  [ALL_APP_IDS.SOURCING]: {
    id: ALL_APP_IDS.SOURCING,
    name: 'Sourcing',
    icon: IconSend,
    path: '/sourcing',
    appGroup: ALL_APP_GROUPS.PROCUREMENT,
    includeInSidebar: true,
    globalEnabled: false,
    globalComingSoon: false,
    views: viewMap([
      ALL_VIEW_IDS.SOURCING_DASHBOARD,
      ALL_VIEW_IDS.SOURCING_RFQS,
      ALL_VIEW_IDS.RFQ,
      ALL_VIEW_IDS.QUOTE,
      ALL_VIEW_IDS.SUPPLIER_SEARCH,
    ]),
    features: featureMap([ALL_FEATURE_IDS.SIMPLIFIED_BUYING]),
  },
  [ALL_APP_IDS.PROCUREMENT]: {
    id: ALL_APP_IDS.PROCUREMENT,
    name: 'Purchasing',
    icon: IconFileDollar,
    path: '/procurement',
    appGroup: ALL_APP_GROUPS.PROCUREMENT,
    includeInSidebar: true,
    includeInBlended: true,
    globalEnabled: false,
    globalBeta: false,
    views: viewMap([
      ALL_VIEW_IDS.PROCUREMENT_DASHBOARD,
      ALL_VIEW_IDS.PURCHASE_ORDERS,
      ALL_VIEW_IDS.PROCUREMENT_APP_PACKING_SLIPS,
      ALL_VIEW_IDS.SUPPLIER_BILLS,
      ALL_VIEW_IDS.PROCUREMENT_BROWSER,
    ]),
    features: featureMap([
      ALL_FEATURE_IDS.SUPPLIER_BILLS,
      ALL_FEATURE_IDS.PROCUREMENT_PACKING_SLIPS,
      ALL_FEATURE_IDS.NON_PART_PURCHASE_LINES,
      ALL_FEATURE_IDS.PROCESSING_ORG_EMAIL,
      ALL_FEATURE_IDS.PROCESSING_ORG,
      ALL_FEATURE_IDS.PROCUREMENT_BROWSER,
    ]),
  },
  [ALL_APP_IDS.DOCAI]: {
    id: ALL_APP_IDS.DOCAI,
    name: 'DocAI',
    icon: IconFileTextSpark,
    path: '/docai',
    appGroup: ALL_APP_GROUPS.PROCUREMENT,
    includeInSidebar: true,
    includeInBlended: true,
    globalEnabled: false,
    globalBeta: false,
    views: viewMap([ALL_VIEW_IDS.DOC_AI_INBOX, ALL_VIEW_IDS.RECEIVE_AI_INBOX]),
    features: featureMap([
      ALL_FEATURE_IDS.PROCESSING_ORG_SCAN,
      ALL_FEATURE_IDS.PROCESSING_ORG_EMAIL,
      ALL_FEATURE_IDS.RECEIVE_AI_INBOX,
    ]),
  },
  [ALL_APP_IDS.ORDERS]: {
    id: ALL_APP_IDS.ORDERS,
    name: 'Orders',
    icon: IconTruckDelivery,
    path: '/orders',
    deprecatedPath: '/purchasing/orders',
    appGroup: ALL_APP_GROUPS.PROCUREMENT,
    includeInSidebar: true,
    includeInBlended: true,
    globalEnabled: false,
    isRequiredFor: [ALL_APP_IDS.BILLING],
    views: viewMap([
      ALL_VIEW_IDS.YOUR_ORDERS,
      ALL_VIEW_IDS.ORDERS_STATUS,
      ALL_VIEW_IDS.ORDERS_TABLE,
      ALL_VIEW_IDS.ORDER_PREFERENCES,
      ALL_VIEW_IDS.CARTS,
    ]),
    features: featureMap([
      ALL_FEATURE_IDS.DROP_SHIPPING,
      ALL_FEATURE_IDS.ORDER_APPROVALS,
      ALL_FEATURE_IDS.PURCHASING_RELEASE_DATES,
    ]),
    shortcuts: ['BILLING.views.BILLING_INVOICES'],
  },
  [ALL_APP_IDS.SIMPLIFIED_BUYING_ORDERS]: {
    id: ALL_APP_IDS.SIMPLIFIED_BUYING_ORDERS,
    name: 'Orders',
    icon: IconShoppingCart,
    path: '/cart-orders',
    appGroup: ALL_APP_GROUPS.PROCUREMENT,
    includeInSidebar: true,
    globalEnabled: false,
    views: viewMap([
      ALL_VIEW_IDS.ORDERS_DASHBOARD,
      ALL_VIEW_IDS.ALL_ORDERS,
      ALL_VIEW_IDS.SUPPLIER_ORDERS,
      ALL_VIEW_IDS.OPEN_CART,
    ]),
    features: featureMap([ALL_FEATURE_IDS.SIMPLIFIED_BUYING]),
  },
  [ALL_APP_IDS.KITTING]: {
    id: ALL_APP_IDS.KITTING,
    name: 'Kitting & Shipping',
    icon: IconPlaneDeparture,
    path: '/kitting/ship-to-warehouse',
    deprecatedPath: '/kitting',
    appGroup: ALL_APP_GROUPS.INVENTORY,
    includeInSidebar: true,
    globalEnabled: false,
    isRequiredFor: [ALL_APP_IDS.MANAGED_INVENTORY, ALL_APP_IDS.WAREHOUSE],
    views: viewMap([
      ALL_VIEW_IDS.KITS,
      ALL_VIEW_IDS.SHIPMENTS,
      ALL_VIEW_IDS.WAREHOUSE_SHIPMENTS,
      ALL_VIEW_IDS.ADDRESSES,
    ]),
    features: featureMap([
      ALL_FEATURE_IDS.CUSTOM_SHIPPING_ACCOUNTS,
      ALL_FEATURE_IDS.SHIP_TO_WAREHOUSE,
      ALL_FEATURE_IDS.LEGACY_SHIPMENTS,
    ]),
    shortcuts: ['MANAGED_INVENTORY.views.STOCK_LOCATIONS'],
  },
  [ALL_APP_IDS.STOCK]: {
    id: ALL_APP_IDS.STOCK,
    name: 'Stock',
    icon: IconPackage,
    path: '/stock',
    appGroup: ALL_APP_GROUPS.INVENTORY,
    includeInSidebar: true,
    includeInBlended: true,
    globalEnabled: false,
    isRequiredFor: [
      ALL_APP_IDS.KITTING,
      ALL_APP_IDS.MANAGED_INVENTORY,
      ALL_APP_IDS.WAREHOUSE,
    ],
    views: viewMap([
      ALL_VIEW_IDS.PART_STOCK,
      ALL_VIEW_IDS.STOCK_LOTS,
      ALL_VIEW_IDS.ALLOCATIONS,
    ]),
    shortcuts: ['KITTING.views.ADDRESSES'],
  },
  [ALL_APP_IDS.MANAGED_INVENTORY]: {
    id: ALL_APP_IDS.MANAGED_INVENTORY,
    name: 'Managed Inventory',
    icon: IconArchive,
    path: '/managed-inventory',
    appGroup: ALL_APP_GROUPS.INVENTORY,
    includeInSidebar: true,
    globalEnabled: false,
    isRequiredFor: [ALL_APP_IDS.WAREHOUSE],
    views: viewMap([ALL_VIEW_IDS.HANDLING_TASKS, ALL_VIEW_IDS.STOCK_LOCATIONS]),
    shortcuts: ['KITTING.views.ADDRESSES'],
  },
  [ALL_APP_IDS.WAREHOUSE]: {
    id: ALL_APP_IDS.WAREHOUSE,
    name: 'Warehouse',
    icon: IconBuildingWarehouse,
    path: MANAGED_INVENTORY_ROUTES.DASHBOARD,
    appGroup: ALL_APP_GROUPS.INVENTORY,
    includeInSidebar: true,
    globalEnabled: false,
    includeInBlended: true,
    features: featureMap([ALL_FEATURE_IDS.BULK_CREATE_EXPECTED]),
  },
  [ALL_APP_IDS.PRODUCTION]: {
    id: ALL_APP_IDS.PRODUCTION,
    name: 'Programs',
    icon: IconCalendarEvent,
    path: '/programs',
    deprecatedPath: '/production',
    appGroup: null,
    includeInSidebar: true,
    globalEnabled: false,
  },
  [ALL_APP_IDS.USERS]: {
    id: ALL_APP_IDS.USERS,
    name: 'Users',
    icon: IconUsers,
    path: '/users',
    appGroup: null,
    includeInSidebar: false,
    globalEnabled: false,
    includeInSettingsMenu: true,
    requiredPermissionLevel: appPermissionAccessLevels.read,
    onboardingNotRequired: true,
    features: featureMap([
      ALL_FEATURE_IDS.APP_LEVEL_PERMISSIONS,
      ALL_FEATURE_IDS.CREATE_EDIT_USER,
      ALL_FEATURE_IDS.CREATE_READ_USER,
    ]),
  },
  [ALL_APP_IDS.ORG_SETTINGS]: {
    id: ALL_APP_IDS.ORG_SETTINGS,
    name: 'Organization Settings',
    icon: IconSettings,
    path: '/org',
    appGroup: null,
    includeInSidebar: false,
    globalEnabled: false,
    includeInSettingsMenu: true,
    requiredPermissionLevel: appPermissionAccessLevels.read,
    onboardingNotRequired: true,
    features: featureMap([
      ALL_FEATURE_IDS.SUB_ORGS,
      ALL_FEATURE_IDS.FILE_ATTACHMENTS,
    ]),
    shortcuts: ['KITTING.views.ADDRESSES', 'USERS', 'BILLING'],
  },
  [ALL_APP_IDS.USER_SETTINGS]: {
    id: ALL_APP_IDS.USER_SETTINGS,
    name: 'Your Settings',
    icon: IconUser,
    path: '/user-settings',
    deprecatedPath: '/account',
    appGroup: null,
    includeInSidebar: false,
    globalEnabled: true,
    includeInSettingsMenu: true,
    requiredPermissionLevel: appPermissionAccessLevels.edit,
    onboardingNotRequired: true,
    views: viewMap([
      ALL_VIEW_IDS.PROFILE,
      ALL_VIEW_IDS.SECURITY,
      ALL_VIEW_IDS.NOTIFICATIONS,
    ]),
  },
  [ALL_APP_IDS.INTEGRATIONS]: {
    id: ALL_APP_IDS.INTEGRATIONS,
    name: 'Integrations',
    icon: IconPlug,
    path: '/integrations',
    appGroup: null,
    includeInSidebar: false,
    globalEnabled: false,
    includeInSettingsMenu: true,
    views: viewMap([
      ALL_VIEW_IDS.INTEGRATIONS_MARKETPLACE,
      ALL_VIEW_IDS.INTEGRATIONS_DESIGNER,
      ALL_VIEW_IDS.INTEGRATIONS_LEGACY,
    ]),
    features: featureMap([
      ALL_FEATURE_IDS.BOMS_GOOGLE_SHEETS,
      ALL_FEATURE_IDS.BOMS_ALTIUM_365,
      ALL_FEATURE_IDS.ORDERS_GOOGLE_SHEETS,
      ALL_FEATURE_IDS.PART_STOCK_GOOGLE_SHEETS,
      ALL_FEATURE_IDS.STOCK_LOTS_GOOGLE_SHEETS,
      ALL_FEATURE_IDS.CUSTOM_PARTS_FILE,
      ALL_FEATURE_IDS.STOCK_LOTS_FILE,
    ]),
  },
  [ALL_APP_IDS.BILLING]: {
    id: ALL_APP_IDS.BILLING,
    name: 'Billing',
    icon: IconCash,
    path: '/billing',
    appGroup: null,
    includeInSidebar: false,
    globalEnabled: false,
    includeInSettingsMenu: true,
    onboardingNotRequired: true,
    views: viewMap([
      ALL_VIEW_IDS.BILLING_USAGE,
      ALL_VIEW_IDS.BILLING_INVOICES,
      ALL_VIEW_IDS.BILLING_PAYMENTS,
    ]),
    shortcuts: ['ORDERS.views.ORDERS_TABLE'],
  },
  [ALL_APP_IDS.SUPPLIERS]: {
    id: ALL_APP_IDS.SUPPLIERS,
    name: 'Suppliers',
    icon: IconBuildingFactory2,
    path: '/suppliers',
    appGroup: ALL_APP_GROUPS.PROCUREMENT,
    includeInSidebar: true,
    globalEnabled: false,
    isRequiredFor: [
      ALL_APP_IDS.PROCUREMENT,
      ALL_APP_IDS.DOCAI,
      ALL_APP_IDS.ORDERS,
      ALL_APP_IDS.SOURCING,
      ALL_APP_IDS.REQUISITIONS,
    ],
    features: featureMap([
      ALL_FEATURE_IDS.GENERATE_PO,
      ALL_FEATURE_IDS.MANAGED_ORDERS,
      ALL_FEATURE_IDS.CUSTOMER_ORDER_API,
      ALL_FEATURE_IDS.COFACTR_PAY,
      ALL_FEATURE_IDS.SUPPLIER_PRICING_API,
      ALL_FEATURE_IDS.SUPPLIER_ORDER_API,
      ALL_FEATURE_IDS.SUPPLIER_ONLINE_CHECKOUT,
    ]),
  },
  [ALL_APP_IDS.REPORTING]: {
    id: ALL_APP_IDS.REPORTING,
    name: 'Reporting',
    icon: IconReportAnalytics,
    path: '/reporting',
    includeInSidebar: true,
    includeInBlended: true,
    globalEnabled: false,
    views: viewMap([
      ALL_VIEW_IDS.REPORTING_APP_SQL_QUERIES,
      ALL_VIEW_IDS.REPORTING_APP_TEMPLATES,
      ALL_VIEW_IDS.REPORTING_APP_BULK_IMPORT_EXPORT,
    ]),
    features: featureMap([ALL_FEATURE_IDS.SQL_QUERIES]),
  },
  [ALL_APP_IDS.PROPERTIES]: {
    id: ALL_APP_IDS.PROPERTIES,
    name: 'Teams & Tags',
    icon: IconTag,
    path: '/properties',
    includeInSidebar: false,
    globalEnabled: false,
    includeInBlended: true,
    includeInSettingsMenu: true,
    requiredPermissionLevel: appPermissionAccessLevels.read,
    onboardingNotRequired: true,
    views: viewMap([ALL_VIEW_IDS.TEAMS_TABLE, ALL_VIEW_IDS.TAGS]),
  },
};

export const cancellationButtonProps = {
  size: 'medium' as const,
  color: COLOR_OPTIONS.primary,
  sx: { mr: 1 },
};

export const confirmationButtonProps = {
  autoFocus: false as const,
  size: 'medium' as const,
  color: COLOR_OPTIONS.primary,
  variant: 'contained' as const,
};
export const cofactrName = 'Cofactr';
export const cofactrSlug = 'cofactr';

export const PARTS_V1_DEPRECATIONS: {
  apps: ALL_APP_IDS[];
  views: ALL_VIEW_IDS[];
} = {
  apps: [ALL_APP_IDS.PART_LIBRARY, ALL_APP_IDS.PART_SEARCH],
  views: [ALL_VIEW_IDS.PART_ALL],
};

function viewMap(views: ALL_VIEW_IDS[]) {
  return Object.fromEntries(
    views.map((view) => [view, ALL_VIEWS[view]] as const)
  );
}

function featureMap(features: ALL_FEATURE_IDS[]) {
  return Object.fromEntries(
    features.map((feature) => [feature, ALL_FEATURES[feature]] as const)
  );
}
